import React from "react";
import { useFollowButtonStyles } from "../../styles";
import { Button } from '@material-ui/core';

function FollowButton({ side }) {
  const classes = useFollowButtonStyles({ side });
  const [ isFollowing, setFollowing ] = React.useState(false);

  const followButton = (
     <Button
      variant={side ? "text" : "contained"}
      color="primary"
      className={classes.button}
      onClick={() => setFollowing(true)}
     >
       Follow
     </Button>
  )

  const followingButton = (
    <Button
     variant={side ? "text" : "outlined"}
     className={classes.button}
     onClick={() => setFollowing(false)}
     fullWidth
    >
      Following
    </Button>
 )
 
  return isFollowing ? followingButton : followButton;
}

export default FollowButton;
